import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { CalendarDays, Receipt, Plus, Users, LayoutGrid } from 'lucide-react';
import { useState } from 'react';
import MobileAddSheet from './MobileAddSheet';

export default function MobileBottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const [showAddSheet, setShowAddSheet] = useState(false);

  const isActive = (path) => location.pathname === path;

  const tabs = [
    { path: '/appointments', icon: CalendarDays, label: 'Calendar' },
    { path: '/sales', icon: Receipt, label: 'Sales' },
    { type: 'add' },
    { path: '/clients', icon: Users, label: 'Clients' },
    { path: '/more', icon: LayoutGrid, label: 'More' },
  ];

  return (
    <>
      <MobileAddSheet
        open={showAddSheet}
        onClose={() => setShowAddSheet(false)}
        onSelect={(action) => {
          setShowAddSheet(false);
          if (action === 'appointment') {
            navigate('/appointments', { state: { openBooking: true } });
          } else if (action === 'blocked') {
            navigate('/appointments', { state: { openBlocked: true } });
          } else if (action === 'sale') {
            navigate('/appointments', { state: { openSale: true } });
          }
        }}
      />

      <nav
        className="lg:hidden fixed bottom-0 left-0 right-0 z-[9999] bg-white/95 backdrop-blur-xl border-t border-[#E5E7E1] safe-area-bottom"
        style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
        data-testid="mobile-bottom-nav"
      >
        <div className="flex items-end justify-around px-2 pt-1.5 pb-1.5">
          {tabs.map((tab, i) => {
            if (tab.type === 'add') {
              return (
                <button
                  key="add"
                  onClick={() => setShowAddSheet(true)}
                  className="flex flex-col items-center -mt-5"
                  data-testid="mobile-add-btn"
                >
                  <div className="w-14 h-14 rounded-2xl bg-[#556B2F] flex items-center justify-center shadow-lg shadow-[#556B2F]/30 active:scale-95 transition-transform">
                    <Plus size={26} className="text-white" strokeWidth={2.5} />
                  </div>
                </button>
              );
            }

            const Icon = tab.icon;
            const active = isActive(tab.path);

            return (
              <NavLink
                key={tab.path}
                to={tab.path}
                className="flex flex-col items-center gap-0.5 min-w-[56px] py-1"
                data-testid={`mobile-nav-${tab.label.toLowerCase()}`}
              >
                <div className={`p-1.5 rounded-xl transition-all duration-200 ${active ? 'bg-[#E9EDDF]' : ''}`}>
                  <Icon
                    size={22}
                    strokeWidth={active ? 2 : 1.5}
                    className={`transition-colors ${active ? 'text-[#556B2F]' : 'text-[#8B9A6B]'}`}
                  />
                </div>
                <span className={`text-[10px] font-medium transition-colors ${active ? 'text-[#556B2F]' : 'text-[#8B9A6B]'}`}>
                  {tab.label}
                </span>
              </NavLink>
            );
          })}
        </div>
      </nav>
    </>
  );
}
